const forms = [
  {
    name: "Invoices",
    className: "bg-white p-4 rounded-md p-8 w-[100%] mx-auto",
    options: [
      {
        name: "Customer",
        type: "selectandadd",
        path: "/app/customers/add",
        form: {
          name: "customer",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Customer",
          api: "get-all-customers",
          options: null,
          value: null,
          required: false,

        },
      },
      {
        name: "Number",
        type: "input",
        form: {
          type: "text",
          name: "number",
          placeholder: "Invoice number",
          class: "",
          value: "",
          required: false,

        },
      },
      {
        name: "Date",
        type: "date",
        disabledDate: true,
        form: {
          type: "text",
          name: "date",
          placeholder: "Invoice date",
          class: "",
          value: "",
          required: true,

        },
      },
      {
        name: "Due Date",
        type: "date",
        form: {
          type: "text",
          name: "due_date",
          placeholder: "Invoice due date",
          class: "",
          value: "",
          required: false,

        },
      },
      {
        name: "LPO Number",
        type: "input",
        form: {
          type: "text",
          name: "lpo_number",
          placeholder: "Lpo number",
          class: "",
          value: "",
          required: false,

        },
      },
      {
        name: "LPO Date",
        type: "date",
        form: {
          type: "text",
          name: "lpo_date",
          placeholder: "Lpo date",
          class: "",
          value: "",
          required: false,

        },
      },
      {
        name: "Salesman",
        type: "select",
        form: {
          name: "salesman",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Salesman",
          api: "get-all-users",
          options: null,
          value: null,
          required: false,

        },
      },
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,

        },
      },
    ],
  },
];

export default forms;
